import axiosInstance from "../api/axios";
import { useDispatch } from "react-redux";
import { useGetPersonFavouriteIdsListQuery } from "../store/api/filmAPI";
import { setLoginModal } from "../store/slices/modals.slice";

const useActorFavouriteClick = () => {
  const token = localStorage.getItem("accessToken");
  const dispatch = useDispatch();

  const actorFavoritesList = useGetPersonFavouriteIdsListQuery(undefined, {
    skip: !token,
  });

  const actorFavouritesHandler = async (e: any, actor: any, inFav: boolean) => {
    e.stopPropagation();
    if (!token) {
      dispatch(setLoginModal(true));
      return;
    }

    if (inFav) {
      await axiosInstance.delete(`/person/favorites/${actor.id}`);
    } else {
      await axiosInstance.post("/person/favorites", { person: actor.id });
    }

    actorFavoritesList.refetch();
  };

  return {
    actorFavoritesList,
    actorFavouritesHandler,
  };
};

export default useActorFavouriteClick;
